import React, { Component } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

class Banner extends Component {
  render() {
    const images = [
      {
        url: "./home1.jpg",
        caption1:
          "Join a revolutionary cultivation platform designed for wealth cultivators like you. Earn rewards by leveraging time, persuasion, data, and access fees to accomplish simple tasks.", // Your Gateway to Unlimited Wealth Creation!
        caption2: "The Wealth System!",
        caption3: "Sign up today and start earning instantly!",
        action: { title: "Join Now!", url: "https://user.wealthsystem.net/" },
      },
      {
        url: "./home2.jpg",
        caption1:
          "Get 40% of your referrals’ cultivation realm access fees and a share of their earnings as they move up the cultivation realms. More referrals, more earnings!", //Turn Your Efforts Into Real Financial Rewards!
        caption2: "Earn While You Cultivate",
        caption3: "Get 40% of your referrals’ cultivation access fees",
        action: {
          title: "Start Earning",
          url: "https://user.wealthsystem.net/",
        },
      },
      {
        url: "./ai-assist.jpg",
        caption1:
          "Effortlessly advance from the 2nd to the 12th realm with 100% task completion. Experience seamless progression with round-the-clock AI Assistant Support guiding your every step.",
        caption2: "Harness the power of AI-assisted cultivation ",
        caption3:
          "AI assistance makes users work like an Ant and eat like an Elephant in cultivation",
        action: {
          title: "Start Earning",
          url: "https://user.wealthsystem.net/",
        },
      },
      {
        url: "./group-young.jpg",
        caption1:
          "Gain access to exclusive online skills training in high-demand fields. Pass the quizzes with 60%+ scores, and receive business startup grants to launch your dream venture!", //Turn Your Efforts Into Real Financial Rewards!
        caption2: "Online Skills Training & Startup Grants",
        caption3: "Learn, Grow, and Get Funded!",
        action: { title: "Join Now", url: "https://user.wealthsystem.net/" },
      },
    ];

    return (
      <Slide autoplay={true} arrows={false} indicators={true} infinite={true}>
        {images.map((slideImage, index) => (
          <div className="each-slide w3-display-container" key={index}>
            <div
              style={{
                backgroundImage: `url(${slideImage.url})`,
                backgroundPosition: "top-center",
              }}
            >
              <div
                style={{
                  width: "100vw",
                  height: "99vh",
                  background: "#00000076",
                }}
              >
                <div
                  className="each-slide-child w3-display-middle"
                  style={{
                    width: "100vw",
                  }}
                >
                  <div className="Slidetitle">{slideImage.caption2}</div>

                  <div className="Slidetop">{slideImage.caption3}</div>
                  <div className=" Slidedetails">{slideImage.caption1}</div>
                  <a href={slideImage.action.url}>
                    <button className="btn btn-primary   py-2  d-flex">
                      {slideImage.action.title}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slide>
    );
  }
}

export default Banner;
